import _ from 'lodash';
import classnames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Heading from './Heading';
import Template from './_internal/Template';
import Image from './Image';
import {
    TEMPLATE_PROP_TYPES,
    HEADING_PROPS,
} from '../constants/componentPropTypes';

const IMAGE_SIZE = 150;
const DEFAULT_BG_COLOR = 'white';

const _getFeatureListItems = (
    features,
    useRoundImages = false,
    isSmallScreen,
) => {
    const featureContainerClassName = classnames({
        'eds-g-cell eds-g-cell-1-3 eds-l-pad-hor-12': !isSmallScreen,
        'eds-g-cell-12-12 eds-text--center eds-l-pad-hor-8 eds-l-pad-vert-4': isSmallScreen,
    });

    return features.map(({ heading, description, imagePath }) => (
        <div key={`${heading}`} className={featureContainerClassName}>
            <div className="eds-align--center eds-l-pad-bot-4">
                <Image
                    imagePath={imagePath}
                    altDescription={heading}
                    height={IMAGE_SIZE}
                    isFullWidth={false}
                    isRound={useRoundImages}
                />
            </div>
            <h2 className="eds-l-pad-vert-2 eds-text-bl eds-text-color--grey-900 eds-text-weight--heavy">
                {heading}
            </h2>
            <p className="eds-text-bm eds-text-color--grey-600">
                {description}
            </p>
        </div>
    ));
};

export default class ColumnFeatures extends PureComponent {
    static propTypes = {
        ...TEMPLATE_PROP_TYPES,
        bgColor: PropTypes.string,
    };

    static defaultProps = {
        bgColor: DEFAULT_BG_COLOR,
    };

    render() {
        const {
            features,
            pageName,
            useRoundImages,
            bgColor,
            hasMaxWidth,
            hasLessTopPadding,
            ...props
        } = this.props;

        if (!features) {
            return null;
        }

        const largeScreenFeatureList = _getFeatureListItems(
            features,
            useRoundImages,
        );
        const smallScreenlargeScreenFeatureList = _getFeatureListItems(
            features,
            useRoundImages,
            true,
        );
        const headingProps = _.pick(props, HEADING_PROPS);

        const largeScreenFeaturesClassName = classnames(
            'eds-g-cell-12-12',
            'eds-text--center',
            'eds-align--space-around',
            {
                'marketing-container__max-width': !hasMaxWidth,
                'eds-l-pad-vert-12': !hasLessTopPadding,
                'eds-l-pad-top-6 eds-l-pad-bot-12': hasLessTopPadding,
            },
        );

        return (
            <div>
                <Template
                    hasPadding={true}
                    showOnlyLargeScreen={true}
                    useBaseline={true}
                    bgColor={bgColor}
                >
                    <Heading
                        {...headingProps}
                        pageName={pageName}
                        bgColor={bgColor}
                    />
                    <div className={largeScreenFeaturesClassName}>
                        {largeScreenFeatureList}
                    </div>
                </Template>
                <Template
                    hasPadding={true}
                    showOnlySmallScreen={true}
                    bgColor={bgColor}
                >
                    <Heading
                        {...headingProps}
                        pageName={pageName}
                        bgColor={bgColor}
                        alignCenter={true}
                    />
                    {smallScreenlargeScreenFeatureList}
                </Template>
            </div>
        );
    }
}
